/* ═════════════════════════════════════════════════
   KohdeValinta — yksi kohdevalitsin kaikille Tuotanto-näkymille
   (päätös 59, Toni 2.10.2026: «laiteasennus ei oo työkohteittain»;
   pääChat: sama komponentti kuin Hitsauslokissa, ei uutta).

   Ennen tätä Hitsausloki ja Laiteasennus piirsivät kumpikin oman
   <select>-elementtinsä samalla sisällöllä. Kaksi kopiota samasta
   valitsimesta erkanee: toinen sai työmaavihjeen (rivi 91), toinen
   laitemäärän sulkeisiin, ja kumpikaan ei tiennyt toisesta.

   Vaihtoehdot annetaan valmiina: kutsuja päättää mistä lista tulee
   (`/api/kohteet` tai laitteista johdettu — kohde ilman laitetta ei
   ole laitelistassa valinta vaan tyhjä ruutu).
   ═════════════════════════════════════════════════ */
import type { ReactNode } from "react";
import { t } from "./kieli";

export interface KohdeVaihtoehto {
  id: number;
  tunnus?: string | null;
  nimi: string;
  /** Sulkeisiin nimen perään, esim. «3 laitetta». */
  lisa?: string | null;
}

export function KohdeValinta({ arvo, muuta, kohteet, kaikki = t("muu.kv.kaikki"), vihje }: {
  arvo: number | "";
  muuta: (id: number | "") => void;
  kohteet: KohdeVaihtoehto[];
  kaikki?: string;
  vihje?: ReactNode;
}) {
  return (
    <label data-kohdevalinta="">
      {t("kuittaus.kohde")}
      <select value={arvo} onChange={(e) => muuta(e.target.value ? Number(e.target.value) : "")}>
        <option value="">{kaikki}</option>
        {kohteet.map((k) => (
          <option key={k.id} value={k.id}>
            {k.tunnus ? `${k.tunnus} · ` : ""}{k.nimi}{k.lisa ? ` (${k.lisa})` : ""}
          </option>
        ))}
      </select>
      {vihje}
    </label>
  );
}
